import {Box, Dialog, DialogContent, Link} from "@mui/material";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useRecoilState, useRecoilValue } from "recoil";
import { BEEScorecardService } from "../../../Component/Api/BEEScorecard/BEEScorecard";
import { CoreStaticDataService } from "../../../Component/Api/StaticData/CoreStaticDataService";
import { UserService } from "../../../Component/Api/User/UserService";
import { ConfirmationDialog } from "../../../Component/Common/Components/ConfirmationDialog";
import { DataTable } from "../../../Component/Common/Components/DataTable/DataTable";
import { FilterType, IFilter } from "../../../Component/Common/Components/DataTable/Filters";
import { SiteAdminRole, UserAdminRole } from "../../../Component/Common/Constants/UserRoles";
import { ColumnSortOption } from "../../../Component/Model/Dto/ColumnSortOption";
import { ScorecardLicenseSummaryDataCore, ScorecardSearchRequestCore, filterColumnValues } from "../../../Component/Model/Dto/ScorecardLicense";
import { EntriesPerPage } from "../../../Component/Model/Table/Table";
import { defaultObject } from "../../../Component/Model/helpers";
import { GetYearsRange } from "../../../Helpers/yearGeneratorFromCurrent";
import { BBBEEScorecardAtom } from "../../../State/BBBEEScorecard.Atom";
import { UserAtom, userRolesState } from "../../../State/user.Atom";
import { CustomDialogTitle } from "../../Common/Custom/CustomDialogTitle";
import { AssignModal } from "../AssignModal";
import { PendingSubmissionModal } from "../PendingSubmissionModal";
import { ScorecardLicenseModal } from "./ScorecardLicenseModal/ScorecardLicenseModal";
import { ScorecardLicenseTableMapper } from "./ScorecardLicenseTableColumn";
import { WelcomeModal } from "./WelcomeModal/WelcomeModal";
import { Auth } from "../../../Component/Api/Auth/AuthService";
import { UpdateAccountDetailsDto } from "../../../Component/Model/SignIn";
import { MDTypography } from "../../../Component/Common/Components/MDTypography";
import { black } from "../../../Component/Common/Components/BEE123.Constants";
import { ScorecardLockModal } from "./ScorecardLockModal/ScorecardLockModal";

interface IProps {
  isSharedForVerification?: boolean;
  isLocked?: boolean;
}

export const ScorecardLicenseMain = (props: IProps) => {
  const userRoles = useRecoilValue(userRolesState);
  const [currentUser, setCurrentUser] = useRecoilState(UserAtom);
  const [userNames, setUserNames] = useState<filterColumnValues[]>(defaultObject);
  const [beeScoreCardType, setBeeScoreCardType] = useState<filterColumnValues[]>(defaultObject);
  const [yearsRange, setYearsRange] = useState<filterColumnValues[]>(defaultObject);
  const [scorecardYears, setScorecardYears] = useState<[]>([]);
  const [scorecardUsers, setScorecardUsers] = useState<[]>([]);
  const [scorecardsTypeIds, setScorecardsTypeIds] = useState<[]>([]);
  const [scorecardConsolidation, setScorecardConsolidation] = useState<any>(null);
  const [filteredItemsCount, setFilteredItemsCount] = useState<number>(0);
  const [totalItemsCount, setTotalItemsCount] = useState<number>(0);
  const [pageNumber, setPageNumber] = useState<number>(1);
  const [searchValue, setSearchValue] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [columnSortOptions, setColumnSortOptions] = useState<ColumnSortOption[]>([]);

  const [scorecardData, setScorecardData] = useState<ScorecardLicenseSummaryDataCore[]>(defaultObject);
  const [entriesPerPage, setEntriesPerPage] = useState<EntriesPerPage>({
    defaultValue: 10,
  });

  const [showConfirmationDialog, setShowConfirmationDialog] = useState<boolean>(false);
  const [selectedScorecardId, setSelectedScorecardId] = useState<string>("");
  const [showModal, setShowModal] = useState<boolean>(false);
  const [showWelcomeModal, setShowWelcomeModal] = useState<boolean>(false);
  const [showAssignModal, setShowAssignModal] = useState<boolean>(false);
  const [BBBEEScorecard, setBBBEEScorecard] = useRecoilState(BBBEEScorecardAtom);
  const history = useHistory();
  const [showPendingSubmissionModal, setShowPendingSubmissionModal] = useState<boolean>(false);  
  const [showScorecardLockModal, setShowScorecardLockModal] = useState<boolean>(false);

  const getUsers = async () => {
    try {
      const users = await UserService.getNonAdminUsers();
      setUserNames(
        users.data.map((data) => {
          return { key: data.username, val: data.username };
        })
      );
    } catch (error) {
      console.log(error);
    }
  };

  const getScorecardTypes = async () => {
    const scorecardType = await CoreStaticDataService.getBeeScorecardType();
    setBeeScoreCardType(
      scorecardType.data.map((data) => {
        return {
          key: data.name,
          val: data.id
        };
      })
    );
  };

  const setYears = () => {
    const yearsBehind = 10;
    const yearsAhead = 2;
    const years = GetYearsRange(yearsBehind, yearsAhead);
    setYearsRange(
      years.map((data) => {
        return { key: data.toString(), val: data };
      })
    );
  };

  const entriesPerPageChanged = (entriesPerPage: number) => {
    setEntriesPerPage({ defaultValue: entriesPerPage });
    setPageNumber(1);
  };

  const pageNumberChanged = (updatedpageNumber: number) => {
    setPageNumber(updatedpageNumber);
  };

  const searchValueChanged = (value: string) => {
    setSearchValue(value);
  };

  const columnSortingChanged = (sortOption: ColumnSortOption) => {
    setColumnSortOptions([sortOption]);
    setPageNumber(1);
  }
  const handleCloseConfirmation = () => {
    setShowConfirmationDialog(false);
    setSelectedScorecardId("");
  };

  const showDeleteConfirmation = (id: string) => {
    setSelectedScorecardId(id);
    setShowConfirmationDialog(true);
  };

  const handleDelete = async () => {
    try {
      await BEEScorecardService.deleteCoreScorecard(selectedScorecardId);
      toast.success("Successfully deleted scorecard");
      searchScorecardData();
    } catch (error) {
      console.log(error);
    } finally {
      handleCloseConfirmation();
    }
  };
  let userSearchRequest: ScorecardSearchRequestCore = {
    pageNumber: pageNumber,
    pageSize: entriesPerPage.defaultValue!,
    searchValue: searchValue,
    years: [],
    isGroupDataManagement: false,
    scorecardTypeIds: [],
    createdByUserNames: [],
    columnSortOptions: [],
    isSharedForVerification: props.isSharedForVerification,
    isLocked: props.isLocked
  };

  const searchScorecardData = async () => {
    setIsLoading(true);
    try {
      const years: [] = scorecardYears;
      const scorecardTypeIds: [] = scorecardsTypeIds;
      const createdByUserNames: [] = scorecardUsers;
      const isConsolidated: any = scorecardConsolidation;
      userSearchRequest = {
        ...userSearchRequest,
        years,
        scorecardTypeIds,
        isConsolidated,
        createdByUserNames,
        columnSortOptions
      };

      const scorecardSearchResult = await BEEScorecardService.getUserScorecardsCore(userSearchRequest);
      setScorecardData(scorecardSearchResult.data.results);
      setFilteredItemsCount(scorecardSearchResult.data.filteredItemsCount);
      setTotalItemsCount(scorecardSearchResult.data.totalItemsCount);
    } catch (error) {
      console.log(error);
      setScorecardData(defaultObject);
      setFilteredItemsCount(0);
      setTotalItemsCount(0);
    } finally {
      setIsLoading(false);
    }
  };

  const scorecardLicensesFilterData: Array<IFilter> = [
    {
      label: "Scorecard Type:",
      values: beeScoreCardType,
      type: FilterType.multiselect,
      propname: "scorecardTypeIds",
    },
    {
      label: "Is Consolidated:",
      values: [
        { key: "Yes", val: true },
        { key: "No", val: false },
      ],
      type: FilterType.select,
      propname: "isConsolidated",
    },
    {
      label: "User Name",
      values: userNames,
      type: FilterType.multiselect,
      propname: "createdByUserNames",
    },
    {
      label: "Year:",
      values: yearsRange,
      type: FilterType.multiselect,
      propname: "years",
    },
  ];

  const confirmDeleteMessage =
    "Are you sure you want to delete this scorecard?";

  const filtersChanged = async (filterProps: any) => {
    setPageNumber(1);
    const years = filterProps["years"];
    const scorecardTypeIds = filterProps["scorecardTypeIds"];
    const isConsolidated =
      filterProps["isConsolidated"].length == 0
        ? null
        : filterProps["isConsolidated"];
    const createdByUserName = filterProps["createdByUserNames"];
    setScorecardYears(years);
    setScorecardsTypeIds(scorecardTypeIds);
    setScorecardConsolidation(isConsolidated);
    setScorecardUsers(createdByUserName);
  };

  useEffect(() => {
    setShowWelcomeModal(currentUser.isFirstTimeLogin && currentUser.isClient);
    getUsers();
    getScorecardTypes();
    setYears();
  }, []);

  useEffect(() => {
    searchScorecardData();
  }, [
    entriesPerPage,
    pageNumber,
    columnSortOptions,
    searchValue,
    scorecardYears,
    scorecardsTypeIds,
    scorecardConsolidation,
    scorecardUsers,
  ]);

  const handleAssignUser = (id: string) => {
    setSelectedScorecardId(id);
    setShowAssignModal(true);
  };

  const closeAssignUserModal = () => {
    setSelectedScorecardId("");
    setShowAssignModal(false);
  };

  const handleAddScoredcard = () => {
    setShowModal(true);
  };

  const closePendingSubmissionModal = () => {
    setSelectedScorecardId("");
    setShowPendingSubmissionModal(false);
  };

  const closeWelcomeModal = () => {
    const updateDto: UpdateAccountDetailsDto = {
      contactName: currentUser.contactName,
      email: currentUser.email,
      telephone: currentUser.telephone,
      username: currentUser.username,
      changeUsername: false,
      isFirstTimeLogin: false
    };

    Auth.updateAccountDetails(updateDto).then(result => {
      setCurrentUser({
        ...currentUser,
        isFirstTimeLogin: false
      });
    });
    setShowWelcomeModal(false);
  };

  const showLockModal = (id: string) => {
    setSelectedScorecardId(id);
    setShowScorecardLockModal(true);
  };

  const handleCloseLockModal = () => {
    setShowScorecardLockModal(false);
  }

  const handleGoToVerificationPlanner = (scorecardId: string, scorecardName: string, scorecardTypeId: number) => {
    setBBBEEScorecard({ scorecardId: scorecardId, scorecardName: scorecardName, scorecardTypeId: scorecardTypeId });
    history.push(`/bee/scorecard/${scorecardId}/verificationProcess/plannerAndTracker`);
  }

  const bulkActions = [
    {
      label: "Create Scorecard",
      action: handleAddScoredcard,
    },
  ];

  const tableData = ScorecardLicenseTableMapper(
    scorecardData,
    handleAssignUser,
    showLockModal,
    showDeleteConfirmation,
    handleGoToVerificationPlanner,
    props.isSharedForVerification
  );

  return (
    <>
      {currentUser.isClient &&
        <>
          <Box sx={{
            marginBottom: "15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            padding: "10px",
            paddingLeft: 0,
            paddingBottom: 0
          }}>
            <MDTypography variant="h5" sx={{ display: "flex", alignItems: "flex-start", height: "100%", color: black }}>Welcome {currentUser.contactName}</MDTypography>
            <Link onClick={() => { setShowWelcomeModal(true) }} style={{ cursor: 'pointer' }}>
              <MDTypography variant="subtitle2" color="#097384" style={{ textDecoration: 'underline' }}>
                How it works
              </MDTypography>
            </Link>
          </Box>
          <Box>
            <MDTypography variant="h5" sx={{ display: "flex", alignItems: "flex-start", height: "100%", color: "#097384" }}>Your Scorecards</MDTypography>
          </Box>
        </>
      }

      <DataTable
        key={totalItemsCount}
        table={tableData}
        canSearch
        entriesPerPage={entriesPerPage}
        pageNumber={pageNumber}
        filteredItemsCount={filteredItemsCount}
        totalItemsCount={totalItemsCount}
        entriesPerPageChanged={entriesPerPageChanged}
        pageNumberChanged={pageNumberChanged}
        searchValueChanged={searchValueChanged}
        isLoading={isLoading}
        manualSorting={true}
        columnSortingChanged={columnSortingChanged}
        filters={scorecardLicensesFilterData}
        filtersChanged={filtersChanged}
        {...((!props.isSharedForVerification && (userRoles.includes(SiteAdminRole) || userRoles.includes(UserAdminRole))) ? { bulkActions } : {})}
      />
      <ConfirmationDialog
        showDialog={showConfirmationDialog}
        handleAccept={handleDelete}
        handleCancel={handleCloseConfirmation}
        heading={"Confirm Delete"}
        message={confirmDeleteMessage}
      />
      {showAssignModal && (
        <AssignModal
          id={selectedScorecardId}
          showAssignModal={showAssignModal}
          isOrganisationUserAccess={false}
          closeAssignModal={closeAssignUserModal}
        />
      )}

      <PendingSubmissionModal
        scorecardId={selectedScorecardId}
        showPendingScorecardModal={showPendingSubmissionModal}
        closePendingScorecardModal={closePendingSubmissionModal}
      />

      <Dialog
        open={showModal}
        onClose={() => setShowModal(false)}
        aria-labelledby="form-dialog-title"
        maxWidth="xl"
      >
        <CustomDialogTitle
          id="customized-dialog-title"
          onClose={() => setShowModal(false)}
        >
          Add Scorecard
        </CustomDialogTitle>
        <DialogContent>
          <ScorecardLicenseModal modalDescription={"Summary of Scorecard Licenses"} />
        </DialogContent>
      </Dialog>

      <WelcomeModal
        showWelcomeModal={showWelcomeModal}
        closeWelcomeModal={closeWelcomeModal}
      />
      
      <ScorecardLockModal
        id={selectedScorecardId}
        open={showScorecardLockModal}
        close={handleCloseLockModal}
      />

      
    </>
  );
};
